
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface CategoryFilterProps {
  categories: string[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

const CategoryFilter = ({ 
  categories, 
  selectedCategory, 
  onCategoryChange 
}: CategoryFilterProps) => {
  // Separate "Overall" from other categories
  const overallCategory = categories.find(cat => cat === "Overall") || "Overall";
  const otherCategories = categories.filter(cat => cat !== "Overall");
  
  // Split otherCategories into two rows
  const firstRowCategories = otherCategories.slice(0, 3); // Sales, Marketing, Engineering
  const secondRowCategories = otherCategories.slice(3);   // Support, HR, Finance
  
  return (
    <div>
      <h3 className="text-lg font-medium text-redflags-dark mb-4">Search Risk by Function</h3>
      <Tabs 
        defaultValue="Overall" 
        className="w-full"
        value={selectedCategory}
        onValueChange={onCategoryChange}
      >
        {/* Overall category on its own row */}
        <TabsList className={`mb-4 flex justify-center ${selectedCategory === "Overall" ? "bg-redflags-red" : "bg-transparent"}`}>
          <TabsTrigger 
            key={overallCategory} 
            value={overallCategory}
            className="text-sm px-8 hover:-translate-y-0.5 transition-transform data-[state=active]:bg-redflags-red data-[state=active]:text-white"
          >
            {overallCategory}
          </TabsTrigger>
        </TabsList>
        
        {/* First row of categories (Sales, Marketing, Engineering) - now with same styling as bottom row */}
        <TabsList className="grid grid-cols-3 w-full gap-2 mb-4 bg-transparent">
          {firstRowCategories.map(category => (
            <TabsTrigger 
              key={category} 
              value={category}
              className="text-sm whitespace-nowrap hover:-translate-y-0.5 transition-transform bg-muted data-[state=active]:bg-redflags-red data-[state=active]:text-white"
            >
              {category}
            </TabsTrigger>
          ))}
        </TabsList>
        
        {/* Second row of categories (Support, HR, Finance) */}
        <TabsList className="grid grid-cols-3 w-full gap-2 mb-2 bg-transparent">
          {secondRowCategories.map(category => (
            <TabsTrigger 
              key={category} 
              value={category}
              className="text-sm whitespace-nowrap hover:-translate-y-0.5 transition-transform bg-muted data-[state=active]:bg-redflags-red data-[state=active]:text-white"
            >
              {category}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
};

export default CategoryFilter;
